import { SyntheticEvent, useState } from "react";
import { Dropdown, DropdownProps } from "semantic-ui-react";

import { RECALL_STATUSES } from "models";
import "modules/RecallsDashboard/components/RecallsFilter/RecallsFilter.scss";
import { useUpdateRecallsDashboardFilters } from "modules/RecallsDashboard/hooks";

const ToBeFixedPlaceholderValue = "To Be Fixed";
const NoFilterValue = "all";

const StatusOptions = [
  { key: NoFilterValue, text: "All", value: NoFilterValue },
  { key: ToBeFixedPlaceholderValue, text: "To Be Fixed", value: ToBeFixedPlaceholderValue },
  { key: RECALL_STATUSES.Approved, text: "Approved", value: RECALL_STATUSES.Approved },
  { key: RECALL_STATUSES.DealerSubmit, text: "Dealer Submit", value: RECALL_STATUSES.DealerSubmit },
  { key: RECALL_STATUSES.DraftSaved, text: "Draft Saved", value: RECALL_STATUSES.DraftSaved },
  { key: RECALL_STATUSES.Settled, text: "Settled", value: RECALL_STATUSES.Settled },
  { key: RECALL_STATUSES.ToBeSettled, text: "To Be Settled", value: RECALL_STATUSES.ToBeSettled }
];

export const RecallsFilters = () => {
  const [selectedFilter, setSelectedFilter] = useState(NoFilterValue);
  const updateRecallsDashboardFilters = useUpdateRecallsDashboardFilters();

  const handleChange = (_event: SyntheticEvent<HTMLElement, Event>, { value }: DropdownProps) => {
    if (typeof value === "string") {
      setSelectedFilter(value);
      let status: string | null = value;

      if (value === NoFilterValue) status = null;
      else if (value === ToBeFixedPlaceholderValue) status = "";

      updateRecallsDashboardFilters({ page: 1, status });
    }
  };

  return (
    <Dropdown selection selectOnBlur={false} options={StatusOptions} value={selectedFilter} className="RecallsFilter" placeholder="Status" onChange={handleChange} />
  );
};
